import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-layout-fixed-notifications',
  templateUrl: './fixed-notifications.component.html',
  styleUrls: ['./fixed-notifications.component.scss']
})

export class LayoutFixedNotificationsComponent implements OnInit {

  @Input() title: string;
  @Input() description: string;
  @Input() button: string;
  @Input() status: string;
  
  @ViewChild('notification') notificationElement: ElementRef;
  @Output() clickNotification = new EventEmitter();
  

  constructor() { }

  ngOnInit() {

  }

  emitNotification() {
    this.clickNotification.emit();
  }

  closeNotification() {
    this.notificationElement.nativeElement.remove();
  }
}